
import { Component, Vue, Prop, PropSync, Ref } from "vue-property-decorator";
import { saveConsultation } from "@/api/consultation";

@Component({ name: 'consultation-components-add' })
export default class AddOrEditDialog extends Vue {
  @PropSync("visible") modelVisible!: boolean;
  @PropSync("editData") form!: any; // 编辑时传入的数据
  @Prop() tenConsultationList!: Array<any>;

  @Ref("formRef") readonly formRef!: any;

  organOptions = [
    "心","肺","肝","胆","肾","膀胱","胃","脾","大肠","小肠","三焦"
  ];

  rules = {
    qid: [{ required: true, message: "请选择类型", trigger: "change" }],
    name: [
      { required: true, message: "请输入名称", trigger: "blur" },
      { max: 16, message: "最多16个字", trigger: "blur" },
      // 唯一性校验可在父组件处理
    ],
    diagResult: [
      // { required: true, message: "请输入诊断结果", trigger: "blur" },
      { max: 16, message: "最多16个字", trigger: "blur" }
    ],
    // relationVisceraList: [{ required: true, message: "请选择对应脏腑" }],
    suitable: [{ required: true, message: "请选择适用人群", trigger: "change" }],
    // symptomStatus: [{ required: true, type: "number", message: "请选择状态", trigger: "change" }]
  };

  mounted() {
    // if (this.isEdit && this.editData) {
    //   this.form = { ...this.editData };
    // }
  }

  saveConsultation() {
    saveConsultation({ ...this.form, symptomStatus: Number(this.form.symptomStatus) }).then((res: any) => {
      this.$message.success("保存成功");
      this.$emit("refreshList")
      this.handleCancel();
    });
  }

  handleSave() {
    this.formRef?.validate((valid: boolean) => {
      console.log(valid);
      if (valid) {
        this.saveConsultation();
      }
    });
  }

  handleCancel() {
    this.modelVisible = false;
    this.formRef.resetFields();
    this.form = {};
  }
}
